export default (function (theme) {
  return {
    root: {
      display: 'inline-block',
      cursor: 'pointer',
      lineHeight: 0
    },
    input: {
      display: 'none'
    },
    disabled: {
      cursor: 'default'
    }
  };
});